<template>
  <div class="relative w-full h-full overflow-hidden text-white bg-black">
    <div v-show="!isLoaded" class="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full">
      <p>Loading...</p>
    </div>

    <template v-if="isLoaded">
      <iframe
        :ref="`iframe-${file.fileRef}`"
        :src="formatIframeSrc()"
        loading="lazy"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowfullscreen="true"
        class="w-full h-full"
      ></iframe>
    </template>
  </div>
</template>

<script>
import BridgeApi from '@/lib/api/bridge'

export default {
  name: 'UtilListingVideo',
  props: {
    file: { type: Object },
    autoPlay: { type: Boolean, default: false },
    preview: { type: Boolean, default: true }
  },
  data() {
    return {
      fileApi: new BridgeApi(),
      video: null,
      isLoaded: false
    }
  },
  computed: {
    isPreview() {
      return this.preview
    }
  },
  watch: {
    file: {
      immediate: true,
      handler() {
        console.log('Getting file in watcher')
        this.getFile()
      }
    }
  },
  methods: {
    async getFile() {
      if (!this.file || this.video) return

      const { fileRef } = this.file
      if (this.fileApi) {
        await this.fileApi.get(`/v1/files/${fileRef}`)

        if (this.fileApi.data) {
          const { readyToStream } = this.fileApi.data

          if (readyToStream === false) {
            setTimeout(() => {
              this.getFile()
            }, 5000)

            return
          }

          this.video = this.fileApi.data
          this.isLoaded = this.fileApi.loading !== true
        }
      }
    },
    formatIframeSrc() {
      const file = this.video || this.file
      if (!file || !file.uid) return ''
      const url = new URL(`https://customer-nr6vj2knd3ksfi7x.cloudflarestream.com/${file.uid}/iframe`)

      url.searchParams.set('muted', true)
      url.searchParams.set('primaryColor', '#FFFFFF')

      if (this.autoPlay) {
        url.searchParams.set('autoplay', true)
        url.searchParams.set('loop', true)
      } else {
        url.searchParams.set('autoplay', false)
      }

      return url.toString()
    },
    formatPreviewUrl(video) {
      const { thumbnail } = video || {}
      if (!thumbnail) return ''
      const gifUrl = thumbnail.replace(/\.jpg$/, '.gif')
      const url = new URL(gifUrl)
      url.searchParams.set('time', '1s')
      url.searchParams.set('height', '200')
      url.searchParams.set('duration', '4s')
      return url.toString()
    },
    async stopVideo() {
      const player = window.Stream(this.$refs[`iframe-${this.file.fileRef}`])

      if (player) {
        await this.$nextTick()
        player.pause().catch(err => {
          console.error('Error pausing video:', err)
        })
      }
    }
  },
  mounted() {
    this.getFile()
  }
}
</script>
